// Map autocomplete for that will be attached to the search form
//

window.addEventListener('DOMContentLoaded', function (e) {

    // Start the call for the maps api
    // createAutocompleteInstance();
});


export default function () {

    console.log('map autocomplete');
    createAutocompleteInstance();
    floatingLabel();
}




// Create the variables needed to stat the autocomplete form instance
let streetAddress;

/**
 * Appraisal form floating label events and behaviour
 */
const floatingLabel = () => {
    let $formFloat = document.querySelectorAll('.form-float');

    $formFloat.forEach($ff => {
        let $label = $ff.querySelector('.label');
        let $searchForm = $ff.querySelector('.form-search');

        // Check if search form contains value
        if ($searchForm.value !== "") {
            labelActive();
        }

        // Focus event for search form
        $searchForm.addEventListener('focus', e => {
            labelActive();
        });

        // Blur event for search form
        $searchForm.addEventListener('blur', e => {
            if (e.target.value == "") {
                labelOff();
            }
        });

        // Active state controller
        function labelActive() {
            if (!$label.classList.contains('float')) {
                $label.classList.add('float');
            }
        }

        // Blur state controller
        function labelOff() {
            if ($label.classList.contains('float')) {
                $label.classList.remove('float');
            }
        }
    });



} // End floating label



/***
 * Start the map process that calls the google maps api
 */
const createAutocompleteInstance = () => {
    let $formAppraisal = document.querySelectorAll('.appraisal-search-form .form-search');

    // immediatly return the user when the form apparisal is not inside the DOM
    if (!$formAppraisal) {
        return
    }



    // Create autocomplete instance that includes options to get the necessary information
    // from google maps

    $formAppraisal.forEach($fa => {
        let autocomplete = new google.maps.places.Autocomplete($fa, {
            componentRestrictions: { country: "au" },
            fields: [
                "address_components",
                "geometry"
            ],
            types: [
                "address"
            ]
        });

        // $formAppraisal.focus();

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            let $container = $fa.parentElement.parentElement;
            let $addressStreetNum = $container.querySelector('[name="input-address-street-number"]');
            let $addressStreetName = $container.querySelector('[name="input-address-street-name"]');
            let $addressSuburb = $container.querySelector('[name="input-address-suburb"]');
            let $addressState = $container.querySelector('[name="input-address-state"]');
            let $addressPostcode = $container.querySelector('[name="input-address-postcode"]');
            let $latitude = $container.querySelector('[name="input-address-latitude"]');
            let $longitude = $container.querySelector('[name="input-address-longitude"]');

            // loop results
            for (const component of place.address_components) {
                // @ts-ignore remove once typings fixed
                let componentType = component.types[0];

                // add the address to the model inputs
                switch (componentType) {
                    case "street_number": {
                        $addressStreetNum.value = component.short_name
                        streetAddress = component.short_name;
                    }
                    case "route": {
                        $addressStreetName.value = component.long_name
                        streetAddress += component.long_name
                    }

                    case "locality": {
                        $addressSuburb.value = component.long_name
                    }

                    case "administrative_area_level_1": {
                        $addressState.value = component.short_name
                    }

                    case "postal_code": {
                        $addressPostcode.value = component.long_name;
                    }
                }
            }

            // Add long and lat to the model inputs
            $longitude.value = place.geometry.location.lng();
            $latitude.value = place.geometry.location.lat();
        });

    });



}

/**
 * Function that recieves and process the address from the google map
 */
const fillInAddress = (autocomplete) => {


}